<template>
  <div class="text-left">

    <div class="row">
      <div class="col-sm-7">
        <div class="info">
        <h2 class="title">{{dealer.fantasy_name}} <span class="text-muted small">({{dealer.id}})</span></h2>
          <p><i class="fa fa-user text-muted mr-1"></i> RUT: <span class="text-muted"> {{dealer.rut}}</span></p>
          <p> <i class="fa fa-map-marker text-muted mr-1"></i> Dirección: <span class="text-muted"> {{dealer.address}}</span></p>
          <p><i class="fa fa-envelope text-muted mr-1"></i> Email: <span class="text-muted"> {{dealer.user_email}}</span></p>
          <ul class="list-inline">
            <li class="list-inline-item"><i class="fa fa-phone text-muted mr-1"></i> Teléfonos: </li>
            <li v-for="(phone, index) in dealer.phones" :key="'phone'+index" class="list-inline-item text-muted"> {{phone}}</li>
          </ul>
          <p><i class="fa fa-card text-muted mr-1"></i> Identificador: <span class="text-muted"> {{dealer.identifier}}</span></p>
        </div>

        <div class="my-4" v-if="dealer.hasCP && loadingStatus != null">
          <span class="badge bg-white text-info" v-if="loadingStatus"><i class="fa fa-spinner fa-spin mr-2 text-primary"></i> Cargando...</span>
          <span v-else class="badge" :class="!loading && !loadingStatus && isActive ? 'badge-success':'badge-danger'">Cliente {{isActive ? 'activo':'bloqueado'}}</span>
        </div>

      </div>
      <div class="col-sm-5" v-if="dealer.hasCP">
        <div class="table-container">
          <table class="table">
            <thead class="bg-secondary">
              <tr>
                <td class="text-center p-1 small">Avisos publicados</td>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td class="text-center" colspan="4">Cargando inventario...</td>
              </tr>
              <tr v-else>
                <td class="text-center">
                  <h2>{{count}}</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="col-sm-5">
        <div class="alert alert-warning">
            <strong><i class="fa fa-warning mr-2"></i> Atención</strong><br>
            Este Cliente no ha sido migrado a <strong>Control Panel</strong>.
        </div>

      </div>
    </div>

    

  </div>
</template>
<script>
export default {
  name: "DealerHeader",
  props: ["dealer", "count", "loading", "loadingStatus", "isActive"]
};
</script>

<style lang="scss" scoped>
  .info {
    font-size: 14px!important;
    > p {
      font-size: 14px!important;
      margin-bottom: 5px;
    }

    .title {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .action {
    cursor: pointer;
  }
</style>